const greenTheme = {
  name: 'Forest Green',
  colors: {
    // Main backgrounds  
    background: '#f0fdf4',        // green-50
    surface: '#ffffff',           // white
    
    // Interactive elements
    primary: '#16a34a',          // green-600
    primaryHover: '#15803d',     // green-700
    primaryDark: '#166534',      // green-800
    secondary: '#22c55e',        // green-500
    accent: '#6b7280',           // gray-500
    
    // Text hierarchy
    text: {
      primary: '#1f2937',        // gray-800
      secondary: '#16a34a',      // green-600
      muted: '#6b7280',          // gray-500
      disabled: '#9ca3af',       // gray-400
      button: '#ffffff',         // white
      link: '#15803d',           // green-700
      linkHover: '#14532d'       // green-900
    },
    
    // Status & feedback
    status: {
      success: '#16a34a',        // green-600
      successBg: '#f0fdf4',      // green-50
      error: '#dc2626',          // red-600
      errorBg: '#fef2f2',        // red-50
      warning: '#d97706',        // orange-600
      warningBg: '#fffbeb',      // orange-50
      warningText: '#ea580c',    // orange-600
      info: '#2563eb',           // blue-600
      victory: '#15803d',        // green-700
      victoryTo: '#166534',      // green-800
      defeat: '#b91c1c',         // red-700
      defeatTo: '#991b1b',       // red-800
      errorHover: '#dc2626'      // red-600
    },
    
    // Interactive states
    hover: {
      light: '#f9fafb',          // gray-50
      medium: '#dcfce7',         // green-100
      surface: '#f3f4f6'         // gray-100
    },
    
    // Borders & separators
    border: {
      light: '#e5e7eb',          // gray-200
      medium: '#d1d5db',         // gray-300
      strong: '#6b7280'          // gray-500
    },
    
    // Badges & tags
    badge: {
      waiting: { bg: '#fef3c7', text: '#d97706' },    // yellow-100/orange-600
      active: { bg: '#f3f4f6', text: '#374151' },     // gray-100/gray-700
      yourTurn: { bg: '#16a34a', text: '#ffffff' },   // green-600/white
      opponentTurn: { bg: '#f3f4f6', text: '#6b7280' }, // gray-100/gray-500
      win: { bg: '#22c55e', text: '#ffffff' },        // green-500/white
      loss: { bg: '#ef4444', text: '#ffffff' }        // red-500/white
    },
    
    // Game-specific
    game: {
      flagClaimed: '#bbf7d0',      // green-200
      flagClaimedBorder: '#16a34a', // green-600
      flagLost: '#fecaca',         // red-200
      flagLostBorder: '#dc2626',   // red-600
      flagNeutral: '#f9fafb',      // gray-50
      flagNeutralBorder: '#d1d5db', // gray-300
      flagHighlight: '#dbeafe',    // blue-100
      chatBackground: '#f9fafb',   // gray-50
      // Invite/waiting states
      inviteBackground: 'rgba(152, 193, 217, 0.2)',
      inviteBorder: '#6969b3',
      inviteText: '#25171a',
      inviteInputBg: 'rgba(255, 255, 255, 0.9)',
      joinBackground: 'rgba(34, 197, 94, 0.2)',
      joinBorder: '#22c55e',
      loadingText: '#98c1d9',
      // Chat error border
      chatErrorBorder: '#fecaca',
      // Button colors
      buttonPrimary: '#374151',
      buttonPrimaryHover: '#1f2937',
      buttonSecondary: '#f3f4f6'
    }
  }
};

export default greenTheme;